import { render, staticRenderFns } from "./S2-CheckboxSizePrice.vue?vue&type=template&id=d66c57dc&scoped=true"
import script from "./S2-CheckboxSizePrice.vue?vue&type=script&lang=js"
export * from "./S2-CheckboxSizePrice.vue?vue&type=script&lang=js"
import style0 from "./S2-CheckboxSizePrice.vue?vue&type=style&index=0&id=d66c57dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d66c57dc",
  null
  
)

export default component.exports